import './styles.css';
import { renderApp } from './app';

renderApp();
